import React from 'react';
import Dedications from '../Dedications';
import { DedicationEdit } from '@/utils/svgIcons';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

export default function EditStep({
  childgender,
  product,
  setInputDedication,
  inputDedication,
  setOption,
  nameFromPersonalize,
  croppedImage,
  setCroppedImage,
  imageSelected,
  setImageSelected,
  updateDedicationImage,
  effectiveImageSelected,
  croppedFile,
  setCroppedFile,
  imageInEdit
}: any) {
  const {t} = useTranslation('personalizeModal');
  const {locale} = useRouter();
  return (
    <div className='flex-1 lg:hidden overflow-y-auto bg-[#E8EADE] text-black h-full'
    dir={`${locale === 'ar' ? 'rtl': 'ltr'}`}
    >
      <div className='m-2 flex flex-col'>
        <div className='bg-white p-4 rounded-t-lg flex flex-col items-start justify-center gap-1'>
          <div className='flex items-center justify-center gap-2'>
            <DedicationEdit/>
            <h2 className={`text-md lg:text-lg font-semibold ${locale === 'ar' ? 'text-right': 'text-left mt-2'}`}>{t('dedicationTextHeading')}</h2>
          </div>
          <h4 className={`text-sm font-light ${locale === 'ar' ? 'text-right mr-8': 'text-left ml-8'}`}>{t('dedicationTextSubHeading')}</h4>
        </div>
        <Dedications
          setInputDedication={setInputDedication}
          inputDedication={inputDedication}
          setOption={setOption}
          gender={childgender}
          product={product}
          nameFromPersonalize={nameFromPersonalize}
          croppedImage={croppedImage}
          setCroppedImage={setCroppedImage}
          imageSelected={imageSelected}
          setImageSelected={setImageSelected}
          updateDedicationImage={updateDedicationImage}
          effectiveImageSelected={effectiveImageSelected}
          croppedFile={croppedFile}
          setCroppedFile={setCroppedFile}
          imageInEdit={imageInEdit}
        />
      </div>
    </div>
  );
}